import * as Y from 'yjs'
import { WebsocketProvider } from 'y-websocket'

export interface WhiteboardProviderResult {
  doc: Y.Doc
  provider: WebsocketProvider
  destroy: () => void
}

/**
 * Create a Yjs document + WebSocket provider for whiteboard CRDT sync.
 * One Y.Doc per visio room, room name = "whiteboard-{roomId}".
 */
export function createWhiteboardProvider(roomId: string): WhiteboardProviderResult {
  const doc = new Y.Doc()
  const roomName = `whiteboard-${roomId}`

  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const wsUrl = `${proto}//${window.location.host}/whiteboard-ws`

  const provider = new WebsocketProvider(wsUrl, roomName, doc, {
    connect: true,
    // Awareness is used by Excalidraw for cursor presence
  })

  const destroy = () => {
    provider.disconnect()
    provider.destroy()
    doc.destroy()
  }

  return { doc, provider, destroy }
}
